import React, { useState, useEffect } from "react";

const Login = () => {

    const [toggle, setToggle] = useState(false);

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const [direct, setDirect] = useState(0);
    const [milap, setMilap] = useState(0);
    const [ketto, setKetto] = useState(0);
    const [impactGuru, setImpactGuru] = useState(0); 

    const login = () => {
        if(email !== "sendmail2nithya@gmail.com"){
            alert("invalid email");
            return;
        }

        if(password !== "asconic@1987"){
            alert("invalid password");
            return;
        }

        setToggle(true);
    }

    const getData = async () => {

        fetch("https://603a5909f1d6aa0017a107e1.mockapi.io/api/v1/Data/1", {
            method: "GET",
            headers: {
                "content-type": "Application/json"
            }
        }).then(res => {
            if(res.status === 200){
                res.json()
                .then(data => {
                    setDirect(data.direct);
                    setMilap(data.milap);
                    setKetto(data.ketto);
                    setImpactGuru(data.impactGuru);
                })
                .catch(err => console.log(err))
            }else{
                res.json()
                .then(data => {
                    
                })
                .catch(err => console.log(err))
            }
        }).catch(err => {
            setLoading(false);
            console.log(err);
        })
    };

    const [loading, setLoading] = useState(false);
    const setData = async () => {

        setLoading(true);
        fetch("https://603a5909f1d6aa0017a107e1.mockapi.io/api/v1/Data/1", {
            method: "PUT",
            headers: {
                "content-type": "Application/json"
            },
            body: JSON.stringify({
                direct,
                milap,
                ketto,
                impactGuru,
                updatedAt: Date.now()
            })
        }).then(res => {
            setLoading(false);
            if(res.status === 200){
                res.json()
                .then(data => {
                    // setDirect(data.direct);
                    // setMilap(data.milap);
                    // setKetto(data.ketto);
                    // setImpactGuru(data.impactGuru);
                    alert("Data saved successfully!");
                })
                .catch(err => console.log(err))
            }else{
                res.json()
                .then(data => {
                    
                })
                .catch(err => console.log(err))
            }
        }).catch(err => {
            setLoading(false);
            console.log(err);
        })
    };

    useEffect(() => {
        getData();
    }, [])

    return(
        <div>
            <div className="dashboard_wrapper login">
                {
                    !toggle ?
                    <>
                        <p style={{ marginBottom: 0 }}>Email</p>
                        <input 
                            className="input"
                            value = {email}
                            onChange = {(e) => {
                                setEmail(e.target.value);
                            }}
                        />
                        <p style={{ marginTop: "2rem", marginBottom: 0 }}>Password</p>
                        <input 
                            className="input"
                            value = {password}
                            onChange = {(e) => {
                                setPassword(e.target.value);
                            }}
                        />

                        <div style={{ margin: "4rem 0", textAlign: "center" }}>
                            <button type="button" className="btn btn-primary" onClick={login}>Login</button>
                        </div>
                    </>
                    :
                    <>
                        <p style={{ marginBottom: 0 }}>Bank Direct</p>
                        <input 
                            className="input"
                            value = {direct}
                            onChange = {(e) => {
                                let value = e.target.value.replace(/[^0-9]/, "");
                                setDirect(value);
                            }}
                        />
                        <p style={{ marginBottom: 0 }}>Milap</p>
                        <input 
                            className="input"
                            value = {milap}
                            onChange = {(e) => {
                                let value = e.target.value.replace(/[^0-9]/, "");
                                setMilap(value);
                            }}
                        />
                        <p style={{ marginBottom: 0 }}>Ketto</p>
                        <input 
                            className="input"
                            value = {ketto}
                            onChange = {(e) => {
                                let value = e.target.value.replace(/[^0-9]/, "");
                                setKetto(value);
                            }}
                        />
                        <p style={{ marginBottom: 0 }}>Impact Guru</p>
                        <input 
                            className="input"
                            value = {impactGuru}
                            onChange = {(e) => {
                                let value = e.target.value.replace(/[^0-9]/, "");
                                setImpactGuru(value);
                            }}
                        />

                        <div style={{ margin: "4rem 0", textAlign: "center" }}>
                            {
                                loading ? 
                                <button 
                                    type="button" 
                                    className="btn btn-primary"
                                >Saving Please wait</button>
                                :
                                <button type="button" className="btn btn-primary" onClick={setData}>Save</button>
                            }
                        </div>
                    </>
                }

            </div>
        </div>
    );
};

export default Login;
